import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/paper-with-lock-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/user-outline-grey.svg'
import _imports_2 from '@/assets/img/icon/bus-front-outline-grey.svg'
import _imports_3 from '@/assets/img/icon/check-circle-green.svg'


const _hoisted_1 = { class: "background-grey-1 p-4" }
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon"
}, null, -1)
const _hoisted_6 = { class: "text-base font-bold text-primary" }
const _hoisted_7 = {
  key: 0,
  class: "text-primary text-xs font-normal text-center border-primary py-1 px-2 rounded-md background-blue-4 w-max ml-auto"
}
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "user"
}, null, -1)
const _hoisted_11 = { class: "text-grey text-sm font-medium" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-5",
  alt: "bus"
}, null, -1)
const _hoisted_15 = { class: "text-grey text-sm font-medium" }
const _hoisted_16 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_17 = { class: "text-2xl font-bold text-green text-right" }
const _hoisted_18 = {
  key: 0,
  src: _imports_3,
  alt: "check"
}
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-grey font-bold text-right"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Diterima oleh: ")
const _hoisted_21 = { class: "text-sm font-bold" }
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-grey font-bold text-right"
}
const _hoisted_23 = { class: "mt-4" }

import Card from 'primevue/card'
import { ref, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import moment from 'moment'
import numberFormat from '@/utils/helpers/numberFormat'
import SnackListDetail from './components/lists/SnackListDetail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const dataDummy = ref([
  {
    id: 0,
    name: 'aaa',
    price: 10000,
    sold: 10,
    remain: 20,
    income: 1000000
  },
  {
    id: 1,
    name: 'bbb',
    price: 10000,
    sold: 10,
    remain: 20,
    income: 1000000
  },
  {
    id: 2,
    name: 'ccc',
    price: 10000,
    sold: 10,
    remain: 20,
    income: 1000000
  }
])

const store = useStore()
const route = useRoute()
const dataParent = ref(encryptDecriptMethods.decrypt(route.params.id))
const transactionPpId = dataParent.value?.dataDetail.Id

onMounted(() => {
  // console.log('dataHeader', dataParent)
  const titlePage = dataParent.value?.dataDetail.TrxId ?? '-'
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Approve Roster',
      routeName: 'approve-snack'
    },
    {
      title: titlePage,
      routeName: 'approve-snack-detail',
      params: { id: route.params.id }
    }
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-list" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(dataParent.value.dataDetail?.TrxId ?? '-'), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(dataParent.value.dataHeader?.PrintCode ?? '-') + "-" + _toDisplayString(_unref(moment)(dataParent.value.dataHeader?.CreatedAt).format('DD MMMM YYYY')), 1),
                (dataParent.value.dataDetail?.HasNonCash)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Non Tunai"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(`Kondektur: ${dataParent.value.dataDetail?.CondecturName ?? '-'}`), 1)
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(`Nopol: ${dataParent.value.dataDetail?.VehicleRegNumber ?? '-'}`), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, "Sisa Snack: " + _toDisplayString(_unref(numberFormat)(dataParent.value.dataDetail?.TotalSnackQuantityLeft ?? 0)) + " Pack", 1),
                (dataParent.value.dataHeader?.Status === 'CompletedSnack')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              (dataParent.value.dataHeader?.Status === 'CompletedSnack')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(dataParent.value.dataHeader?.UpdatedByFullName ?? '-') + " " + _toDisplayString(`(${_unref(moment)(dataParent.value.dataHeader?.UpdatedAt).format('DD MMMM YYYY HH:mm')})`), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, "Belum diterima"))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(SnackListDetail, { transId: _unref(transactionPpId) }, null, 8, ["transId"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})